<template>
  <div class="condition-task-wrapper">
    <div class="modal task" :class="{ customLoader: loading }">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Konditionen</div>
      <div class="content">
        <ConditionBuilderComponent
          v-show="!loading"
          ref="conditionComponentRef"
          :task="{ input: getFilteredInputForConditionBuilder }"
          @onContentChange="onContentChange"
          :apiVersion="getApiVersion"
          :defaultConditions="task.props.conditions"
        ></ConditionBuilderComponent>
      </div>

      <div class="loading-container" v-if="loading">
        <LoadingSpinner loadingCaption="Wird gespeichert..." />
      </div>
    </div>
  </div>
</template>

<script>
import { ConditionBuilderComponent } from '@codelos.io/condition-builder';
import '@codelos.io/condition-builder/dist/condition-builder.css';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { HttpStatusCode } from '../../enum/httpStatus.enum';
import {
  debouncer,
  getApiEndpointVersion,
  LATEST_FLOW_RUNNER_VERSION,
} from '../../utils/helpers';

export default {
  name: 'conditionBuilderWarp',

  props: {
    task: Object,
    flowRunnerEndpoint: {
      type: String,
    },
  },

  data() {
    return {
      outputContent: [],
      loading: false,
    };
  },
  methods: {
    onContentChange(event) {
      this.task.props.conditions = event;
    },

    async close() {
      this.loading = true;
      await this.saveAsOutput();
      setTimeout(() => {
        this.loading = false;
        this.$emit('close');
      }, 1000);
    },

    async saveAsOutput() {
      this.$set(this.task, 'output', this.task.input);
      try {
        const res = await this.$refs.conditionComponentRef.getConditionOutput();
        this.$emit('conditionBuilderResponse', {
          task: this.task,
          res,
        });
        this.$set(this.task, 'status', 'success');
      } catch (err) {
        if (err?.code === HttpStatusCode.INTERNAL_SERVER_ERROR) {
          this.showToaster(
            'Im Zustand ist etwas schief gelaufen',
            'Fehlerhaft !',
            'danger'
          );
        }
        if (err?.code === HttpStatusCode.BAD_REQUEST) {
          this.showToaster(
            'Bitte beheben Sie den Fehler in der Bedingung',
            'Fehlerhaft !',
            'danger'
          );
        }
        this.$set(this.task, 'status', 'error');

        this.$emit('conditionBuilderResponse', { task: this.task, res: false });
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },
  mounted() {
    const scroll = this.$refs['conditionComponentRef']?.$el;
    if (scroll) {
      scroll.addEventListener('scroll', this.showScrollbar);
    }
  },
  destroyed() {
    const scroll = this.$refs['conditionComponentRef']?.$el;
    if (scroll) {
      scroll.removeEventListener('scroll', this.showScrollbar);
    }
  },
  created() {
    if (
      this.task.input &&
      this.task.input.length > 0 &&
      this.task.props.conditions &&
      this.task.props.conditions.length > 0
    ) {
      const tmpConditions = JSON.parse(
        JSON.stringify(this.task.props.conditions)
      );

      tmpConditions.forEach((conditionBlock) => {
        conditionBlock.forEach((singleCondition) => {
          const el1FoundedNewVal = this.task.input.find(
            (input) => input.name === singleCondition.el1.name
          );

          const el2FoundedNewVal = this.task.input.find(
            (input) => input.name === singleCondition.el2.name
          );

          singleCondition.el1.value = el1FoundedNewVal
            ? el1FoundedNewVal.value
            : singleCondition.el1.value;
          singleCondition.el2.value = el2FoundedNewVal
            ? el2FoundedNewVal.value
            : singleCondition.el2.value;
        });
      });
      this.task.props.conditions = tmpConditions;
    }
  },
  computed: {
    getFilteredInputForConditionBuilder() {
      const unwantedTypes = ['file', 'dataframe'];
      return this.task.input.filter(
        (input) =>
          input.label !== 'codelosSettings' &&
          !unwantedTypes.includes(input.type)
      );
    },
    getApiVersion() {
      return (
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION
      );
    },
  },

  components: {
    ConditionBuilderComponent,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.condition-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.condition-task-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.condition-task-wrapper .modal.task {
  padding-inline: 34px !important;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: calc(100% - 36px - 36px);
  margin-top: 36px;
}

.pull-right {
  float: right;
}

::v-deep .column-selector,
::v-deep .row-selector {
  box-shadow: unset;
  padding: 0;
}

::v-deep input {
  box-sizing: border-box;
}
::v-deep .codelos-page-content {
  text-align: left;
  font-size: 16px;
  color: #212529;
}
::v-deep .element-block {
  line-height: 1.5;
}

::v-deep .modal-backdrop.custom-backdrop {
  background: transparent;
}
::v-deep .codelos-dropdown-child,
::v-deep .codelos-dropdown {
  box-sizing: border-box;
}
::v-deep .codelos-dropdown-item {
  line-height: 1.5;
}
.btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 10px;
}

::v-deep .accordion-wrapper,
::v-deep .input-item,
::v-deep .dropdown-item {
  box-sizing: border-box;
}

::v-deep input {
  min-height: 41px;
}
::v-deep .dropdown-menu.show {
  bottom: unset;
}

::v-deep .modal.custom-modal {
  width: 100% !important;
  height: 100% !important;
  left: unset;
  right: unset;
  box-sizing: border-box;
  box-shadow: none;
  border: none;
  position: unset;
  margin: 0;
  padding: 0;
  font-family: inherit;
  border-radius: 0;
  max-width: 100% !important;
}

::v-deep .modal.custom-modal .modal-body {
  padding: 0 !important;
}

::v-deep .modal.custom-modal .modal-title {
  display: none !important;
}

.progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}

.modal .custom-modal::-webkit-scrollbar {
  width: 4px;
}

.modal .custom-modal::-webkit-scrollbar-track {
  border-radius: 7px;
  background-color: transparent;
  border: 1px solid transparent;
}

.modal .custom-modal::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #565656;
}

@media screen and (max-width: 1366px) {
  .modal .custom-modal::-webkit-scrollbar-thumb {
    display: none;
  }
}

.modal .custom-modal.show-scrollbar::-webkit-scrollbar-thumb {
  display: block;
}
</style>
